<sc-master-detail [data]="stationGroups" [selection]="[selectedStationGroup]" [readOnly]="true"
  (selectionChanged)="onSelectionChanged($event);">

  <sc-scroll-pane>
    <sc-padding>

      <ng-container *ngFor="let stationSet of selectedStationGroup?.stationSets; let i = index">

        <sc-content-spacer vertical double *ngIf="i > 0"></sc-content-spacer>

        <div class="station-set-tile" (click)="selectStationSet(stationSet)" [ngClass]="{'selected' : stationSet === selectedStationSet && selectedStation == null,
              'selectable' : request?.scope === StructureSelectionScope.ANY ||
              request?.scope === StructureSelectionScope.STATION_OR_STATION_SET ||
              request?.scope === StructureSelectionScope.STATION_SET ||
              request?.scope === StructureSelectionScope.STATION_SET_OR_STATION_GROUP}">
          <sc-padding>
            {{stationSet.name}}
          </sc-padding>
        </div>
        <sc-content-spacer vertical></sc-content-spacer>

        <sc-items-grid [width]="300" [gap]="16">
          <app-station-details [station]="station" *ngFor="let station of stationSet?.stations" class="station-tile"
            (click)="selectStation(stationSet, station)" [enabled]="(request?.scope === StructureSelectionScope.ANY ||
              request?.scope === StructureSelectionScope.STATION_OR_STATION_SET ||
              request?.scope === StructureSelectionScope.STATION) &&

              ((request?.filter === StructureSelctionFilter.ANY) ||
              (station.stationType === StationType.WORKING_AREA && request?.filter == StructureSelctionFilter.STATION) ||
              (station.stationType === StationType.WAITING_AREA && request?.filter == StructureSelctionFilter.WAITING_AREA))" [ngClass]="{'selectable' :

              (request?.scope === StructureSelectionScope.ANY ||
              request?.scope === StructureSelectionScope.STATION_OR_STATION_SET ||
              request?.scope === StructureSelectionScope.STATION) &&

              ((request?.filter === StructureSelctionFilter.ANY) ||
              (station.stationType === StationType.WORKING_AREA && request?.filter == StructureSelctionFilter.STATION) ||
              (station.stationType === StationType.WAITING_AREA && request?.filter == StructureSelctionFilter.WAITING_AREA))

          }" [selected]="stationSet === selectedStationSet && station === selectedStation"></app-station-details>
        </sc-items-grid>

      </ng-container>

    </sc-padding>
  </sc-scroll-pane>

</sc-master-detail>
